export default "__VITE_ASSET__Dz$SE6Xk__"